<template>
  <div class="big">
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div class="item">
              <span>患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="user_name"
                style="width:160px;margin-left:12px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                style="width:160px;margin-left:12px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>推荐时间</span>
              <el-date-picker
                v-model="recommend"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width:264px;margin-left:12px"
                clearable
                @change="search"
              ></el-date-picker>
            </div>
            <div class="item">
              <span>项目名称</span>
              <el-input
                placeholder="请输入"
                v-model="pro_name"
                style="width:160px;margin-left:12px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>项目类型</span>
              <el-select
                v-model="pro_type"
                placeholder="请选择"
                @change="search"
                style="width:160px;margin-left:12px"
                clearable
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>支付时间</span>
              <el-date-picker
                v-model="pay_time"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width:264px;margin-left:12px"
                @change="search"
                clearable
              ></el-date-picker>
              <el-button
                type="info"
                style="background-color:#eceff2;;color:#747981;margin-left:10px"
                @click="search"
              >查询</el-button>
            </div>
            <div class="item">
              <span style="margin-right:10px">是否到预约日期</span>
              <el-radio-group
                v-model="register_bool"
                @change="search"
              >
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6;">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%;min-width:1000px;"
              :header-cell-style="{background:'#F5F5F5'}"
            >
              <el-table-column label="患者信息">
                <template slot-scope="scope">
                  <div>{{scope.row.user_name}}</div>
                  <div>
                    <span v-if="scope.row.sex==1">男</span>
                    <span v-if="scope.row.sex==2">女</span>
                    <span v-if="scope.row.sex==0">未知</span>
                    <span style="margin-left:15px">{{scope.row.age}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="医生信息">
                <template slot-scope="scope">
                  <div>{{scope.row.doctor_name}}</div>
                  <div>
                    <span v-if="scope.row.doctor_sex==1">男</span>
                    <span v-if="scope.row.doctor_sex==2">女</span>
                    <span v-if="scope.row.doctor_sex==0">未知</span>
                    <span style="margin-left:15px">{{scope.row.doctor_title}}</span>
                  </div>
                  <div>{{scope.row.doctor_phone}}</div>
                </template>
              </el-table-column>
              <el-table-column label="项目类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.pro_type==1">体检项目</div>
                </template>
              </el-table-column>
              <el-table-column
                label="项目名称"
                prop="pro_name"
              ></el-table-column>
              <el-table-column
                label="销售价格"
                prop="price"
              ></el-table-column>
              <el-table-column label="订单状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.status==1">未支付</div>
                  <div
                    v-if="scope.row.status==2"
                    class="confirmbox"
                  >
                    <div>已支付</div>
                    <div
                      class="confirm"
                      v-if="scope.row.market_status==1"
                    >业务员已确认</div>
                  </div>
                  <div v-if="scope.row.status==3">已支付</div>
                  <div v-if="scope.row.status==4">已完成</div>
                  <div v-if="scope.row.status==5">已作废</div>
                  <div v-if="scope.row.status==6">已作废</div>
                </template>
              </el-table-column>
              <el-table-column
                label="推荐时间"
                prop="recommend_time"
              ></el-table-column>
              <el-table-column
                label="支付时间"
                prop="pay_time"
              ></el-table-column>
              <el-table-column label="预约时间">
                <template slot-scope="scope">
                  <div :style="scope.row.is_late?'color:#FF3200':''">{{scope.row.register_time}}</div>
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="toDetail(scope.row.order_id)"
                    :disabled="module_id_array[0]?!module_id_array.includes('297'):false"
                  >查看</el-button>
                  <el-button
                    type="text"
                    v-if="scope.row.register_time&&scope.row.is_late"
                    @click="finishOrder(scope.row.order_id,scope.row.market_status)"
                    :disabled="module_id_array[0]?!module_id_array.includes('298'):false"
                  >完成</el-button>
                  <el-button
                    type="text"
                    @click="refund(scope.row.order_id)"
                    :disabled="module_id_array[0]?!module_id_array.includes('299'):false"
                  >退款</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import marketing from '../../../api/marketing';
import platform from '../../../api/platform';
import moment from 'moment';
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      user_name: '',
      doctor_name: '',
      recommend: [],
      pro_type: '',
      pro_name: '',
      register_bool: '',
      pay_time: [],
      tableData: [],
      options: [
        {
          label: '体检项目',
          value: 1
        }
      ],
      dialog: false,
      orderData: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_name: this.user_name,
        doctor_name: this.doctor_name,
        pro_type: this.pro_type,
        pro_name: this.pro_name,
        recommend_start: '',
        recommend_end: '',
        pay_time_start: '',
        pay_time_end: '',
        order_status: 2,
        register_bool: this.register_bool
      };
      if (this.recommend && this.recommend.length > 0) {
        data.recommend_start = moment(this.recommend[0]).format('YYYY-MM-DD');
        data.recommend_end = moment(this.recommend[1]).format('YYYY-MM-DD');
      }
      if (this.pay_time && this.pay_time.length > 0) {
        data.pay_time_start = moment(this.pay_time[0]).format('YYYY-MM-DD');
        data.pay_time_end = moment(this.pay_time[1]).format('YYYY-MM-DD');
      }
      marketing.getProductOrders(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.recommend_time = moment
              .unix(item.recommend_time)
              .format('YYYY-MM-DD HH:mm');
            item.pay_time = item.pay_time
              ? moment.unix(item.pay_time).format('YYYY-MM-DD HH:mm')
              : '';
            item.register_time = item.register_time
              ? moment.unix(item.register_time).format('YYYY-MM-DD HH:mm')
              : '';
            let now = moment(new Date()).format('YYYY-MM-DD HH:mm');
            if (item.register_time < now) {
              item.is_late = true;
            } else {
              item.is_late = false;
            }
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },

    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //查看订单详情
    toDetail(order_id) {
      this.$router.push({
        path: 'orderdetail',
        query: {
          order_id
        }
      });
    },
    //完成订单
    finishOrder(order_id, market_status) {
      if (market_status) {
        this.$confirm(
          '业务员已经确认体验完成了。是否完成该体检套餐？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }
        )
          .then(() => {
            marketing.updateProductOrderStatus({ order_id }).then((res) => {
              if (res.code == 0) {
                this.$message.success('订单已完成');
                this.getList();
              }
            });
          })
          .catch(() => {});
      } else {
        this.$confirm(
          '业务员还未确认体检是否完成。是否要继续完成该体检套餐？',
          '提示',
          {
            confirmButtonText: '不需确认，继续完成',
            cancelButtonText: '取消'
          }
        )
          .then(() => {
            marketing.updateProductOrderStatus({ order_id }).then((res) => {
              if (res.code == 0) {
                this.$message.success('订单已完成');
                this.getList();
              }
            });
          })
          .catch(() => {});
      }
    },
    //退款
    refund(order_id) {
      this.$confirm('确定要退款吗？退款后项目订单将作废', '提示', {
        confirmButtonText: '确定退款',
        cancelButtonText: '取消'
      })
        .then(() => {
          marketing.refundProductOrder({ order_id }).then((res) => {
            if (res.code == 0) {
              this.$message.success('订单已退款');
              this.getList();
            }
          });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item {
      margin-right: 30px;
      margin-top: 24px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.dialog {
  padding: 20px 20px 0;
}
.confirmbox {
  position: relative;
  height: 40px;
  line-height: 40px;
  .confirm {
    position: absolute;
    top: -10px;
    right: 25px;
    font-size: 10px;
    color: #ff3200;
  }
}
</style>
